import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/upload.png'


const _withScopeId = n => (_pushScopeId("data-v-828bea96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "__employee-detail p-10 pb-30 md-down:px-4" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center" }
const _hoisted_4 = { class: "__breadcrumbs__decorate" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Hồ sơ nhân sự", -1))
const _hoisted_6 = { class: "__employee-detail__header pt-10 pb-10 flex items-center justify-between" }
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "font-medium leading-none text-white text-xl" }
const _hoisted_11 = {
  key: 2,
  class: "absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2 h-14 w-14 rounded-full flex items-center justify-center",
  style: {"min-width":"56px","background-color":"rgba(99, 144, 195, 0.5)"}
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "32",
  viewBox: "0 0 40 40",
  width: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M9.84364 16.0997V10.2496C9.84364 4.86466 14.3907 0.5 20 0.5C25.6093 0.5 30.1564 4.865 30.1564 10.2496V16.0997C33.5218 16.0997 36.25 18.7188 36.25 21.9497V33.6499C36.25 36.8812 33.5218 39.5 30.1564 39.5H9.84364C6.47821 39.5 3.75 36.8812 3.75 33.6499V21.9497C3.75 18.7188 6.47821 16.0997 9.84364 16.0997V16.0997ZM26.0936 16.0997V10.2496C26.0936 7.01866 23.3654 4.3995 20 4.3995C16.6346 4.3995 13.9064 7.01866 13.9064 10.2496V16.0997H26.0936ZM20 23.9C21.1218 23.9 22.0311 24.7729 22.0311 25.8499V29.7501C22.0311 30.8271 21.1218 31.7 20 31.7C18.8782 31.7 17.9689 30.8271 17.9689 29.7501V25.8499C17.9689 24.7729 18.8782 23.9 20 23.9Z",
    fill: "#FAF5F1",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "ml-4" }
const _hoisted_15 = { class: "font-bold text-neutral-700 text-4xl md-down:text-2xl" }
const _hoisted_16 = {
  key: 0,
  class: "text-xs text-neutral-400 flex items-center flex-nowrap"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  fill: "none",
  height: "12",
  viewBox: "0 0 20 20",
  width: "12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM15.0379 6.21209C14.6718 5.84597 14.0782 5.84597 13.7121 6.21209C13.7032 6.22093 13.6949 6.23029 13.6872 6.24013L9.34673 11.7709L6.72983 9.15403C6.36372 8.78791 5.77012 8.78791 5.40401 9.15403C5.03789 9.52015 5.03789 10.1137 5.40401 10.4799L8.71207 13.7879C9.07818 14.154 9.67178 14.154 10.0379 13.7879C10.046 13.7798 10.0537 13.7712 10.0609 13.7622L15.0512 7.52434C15.404 7.15727 15.3995 6.57371 15.0379 6.21209Z",
    fill: "#41BEAD",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_18 = {
  key: 1,
  class: "text-xs text-neutral-400 flex items-center flex-nowrap"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  fill: "none",
  height: "12",
  viewBox: "0 0 20 20",
  width: "12"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM5.83333 9.16667C5.48815 9.16667 5.20833 9.53976 5.20833 10C5.20833 10.4602 5.48815 10.8333 5.83333 10.8333H14.5833C14.9285 10.8333 15.2083 10.4602 15.2083 10C15.2083 9.53976 14.9285 9.16667 14.5833 9.16667H5.83333Z",
    fill: "#E68D7B",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_20 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "button-p text-center mt-6 whitespace-nowrap ml-4 btn--ghost",
  type: "button"
}, " Xem lịch dạy ", -1))
const _hoisted_22 = { class: "__employee-detail__container" }
const _hoisted_23 = { class: "border-b border-neutral-200" }
const _hoisted_24 = {
  "aria-label": "Tabs",
  class: "-mb-px flex space-x-8 tabs"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "mt-6" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = {
  key: 0,
  class: "w-full"
}
const _hoisted_30 = { class: "relative mt-16" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "aria-hidden": "true",
  class: "absolute inset-0 flex items-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-neutral-300" })
], -1))
const _hoisted_32 = { class: "relative flex justify-center" }
const _hoisted_33 = { class: "bg-body px-2 text-neutral-600 font-semibold text-2xl whitespace-nowrap flex flex-nowrap items-center justify-center gap-6" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "12",
  viewBox: "0 0 8 12",
  width: "8",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.5 1L1.5 6L6.5 11",
    stroke: "#48566A",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 0,
  class: "flex items-center gap-2.5 cursor-pointer"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 17 16",
  width: "17",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M4.5 0.5C4.5 0.223858 4.27614 0 4 0C3.72386 0 3.5 0.223858 3.5 0.5V1H2.5C1.39543 1 0.5 1.89543 0.5 3V4H16.5V3C16.5 1.89543 15.6046 1 14.5 1H13.5V0.5C13.5 0.223858 13.2761 0 13 0C12.7239 0 12.5 0.223858 12.5 0.5V1H4.5V0.5ZM16.5 14V5H0.5V14C0.5 15.1046 1.39543 16 2.5 16H14.5C15.6046 16 16.5 15.1046 16.5 14ZM10 7C9.72386 7 9.5 7.22386 9.5 7.5V8.5C9.5 8.77614 9.72386 9 10 9H11C11.2761 9 11.5 8.77614 11.5 8.5V7.5C11.5 7.22386 11.2761 7 11 7H10ZM13 7C12.7239 7 12.5 7.22386 12.5 7.5V8.5C12.5 8.77614 12.7239 9 13 9H14C14.2761 9 14.5 8.77614 14.5 8.5V7.5C14.5 7.22386 14.2761 7 14 7H13ZM2.5 10.5C2.5 10.2239 2.72386 10 3 10H4C4.27614 10 4.5 10.2239 4.5 10.5V11.5C4.5 11.7761 4.27614 12 4 12H3C2.72386 12 2.5 11.7761 2.5 11.5V10.5ZM6 10C5.72386 10 5.5 10.2239 5.5 10.5V11.5C5.5 11.7761 5.72386 12 6 12H7C7.27614 12 7.5 11.7761 7.5 11.5V10.5C7.5 10.2239 7.27614 10 7 10H6Z",
    fill: "#48566A",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "12",
  viewBox: "0 0 8 12",
  width: "8",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 11L6.5 6L1.5 1",
    stroke: "#48566A",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1))
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = { class: "mt-10" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Chuyên cần theo giờ ", -1))
const _hoisted_42 = { class: "grid grid-cols-4 items-start md-down:grid-cols-1 mt-2 gap-4" }
const _hoisted_43 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 20 20",
      width: "20",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 4.375C10 4.02982 9.72018 3.75 9.375 3.75C9.02982 3.75 8.75 4.02982 8.75 4.375V11.25C8.75 11.4743 8.87018 11.6814 9.06491 11.7927L13.4399 14.2927C13.7396 14.4639 14.1214 14.3598 14.2927 14.0601C14.4639 13.7604 14.3598 13.3786 14.0601 13.2073L10 10.8873V4.375Z",
        fill: "#6366F1",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " Số giờ đã dạy / giờ dự kiến ")
], -1))
const _hoisted_45 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_46 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 24 20",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z",
        fill: "#F1A267",
        "fill-rule": "evenodd"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z",
        fill: "#F1A267",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Số giờ dạy phát sinh")
], -1))
const _hoisted_48 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_49 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 24 20",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z",
        fill: "#E68D7B",
        "fill-rule": "evenodd"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z",
        fill: "#E68D7B",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " Số giờ trị liệu viên nghỉ ")
], -1))
const _hoisted_51 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_52 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 24 20",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z",
        fill: "#E68D7B",
        "fill-rule": "evenodd"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z",
        fill: "#E68D7B",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Số giờ học sinh nghỉ")
], -1))
const _hoisted_54 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_55 = {
  key: 0,
  class: "mt-10"
}
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Chuyên cần theo ngày ", -1))
const _hoisted_57 = { class: "grid grid-cols-4 items-start md-down:grid-cols-1 mt-2 gap-4" }
const _hoisted_58 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 20 20",
      width: "20",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 4.375C10 4.02982 9.72018 3.75 9.375 3.75C9.02982 3.75 8.75 4.02982 8.75 4.375V11.25C8.75 11.4743 8.87018 11.6814 9.06491 11.7927L13.4399 14.2927C13.7396 14.4639 14.1214 14.3598 14.2927 14.0601C14.4639 13.7604 14.3598 13.3786 14.0601 13.2073L10 10.8873V4.375Z",
        fill: "#6366F1",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " Số ngày đã dạy / dự kiến ")
], -1))
const _hoisted_60 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_61 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 24 20",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z",
        fill: "#F1A267",
        "fill-rule": "evenodd"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z",
        fill: "#F1A267",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Số ngày học phát sinh")
], -1))
const _hoisted_63 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_64 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 24 20",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z",
        fill: "#E68D7B",
        "fill-rule": "evenodd"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z",
        fill: "#E68D7B",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " Số ngày trị liệu viên nghỉ ")
], -1))
const _hoisted_66 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_67 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 24 20",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z",
        fill: "#E68D7B",
        "fill-rule": "evenodd"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z",
        fill: "#E68D7B",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Số ngày học sinh nghỉ")
], -1))
const _hoisted_69 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_70 = { class: "mt-10" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Tiến độ công việc (hoàn thành/tổng số) ", -1))
const _hoisted_72 = { class: "grid grid-cols-4 items-start md-down:grid-cols-1 mt-2 gap-4" }
const _hoisted_73 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 20 20",
      width: "20",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z",
        fill: "#41BEAD",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Báo cáo can thiệp")
], -1))
const _hoisted_75 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_76 = {
  key: 0,
  class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
}
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 20 20",
      width: "20",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z",
        fill: "#41BEAD",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Báo cáo tuần")
], -1))
const _hoisted_78 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_79 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 20 20",
      width: "20",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z",
        fill: "#41BEAD",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Báo cáo tháng")
], -1))
const _hoisted_81 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_82 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 20 20",
      width: "20",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z",
        fill: "#41BEAD",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Kế hoạch dự kiến")
], -1))
const _hoisted_84 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_85 = { class: "mt-10" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Hình ảnh/ Video upload ", -1))
const _hoisted_87 = { class: "grid grid-cols-3 items-start md-down:grid-cols-1 mt-2 gap-4" }
const _hoisted_88 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 21 20",
      width: "21",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M17.5019 2.5H2.50192C1.81157 2.5 1.25192 3.05964 1.25192 3.75V15L4.55998 12.0581C4.77065 11.8474 5.10072 11.8147 5.34861 11.98L8.67229 14.1958L13.31 9.55807C13.5002 9.36785 13.7908 9.32069 14.0314 9.441L18.7519 11.875V3.75C18.7519 3.05964 18.1923 2.5 17.5019 2.5ZM2.50192 1.25C1.12121 1.25 0.00192261 2.36929 0.00192261 3.75V16.25C0.00192261 17.6307 1.12121 18.75 2.50192 18.75H17.5019C18.8826 18.75 20.0019 17.6307 20.0019 16.25V3.75C20.0019 2.36929 18.8826 1.25 17.5019 1.25H2.50192ZM7.50192 6.875C7.50192 7.91053 6.66246 8.75 5.62692 8.75C4.59139 8.75 3.75192 7.91053 3.75192 6.875C3.75192 5.83947 4.59139 5 5.62692 5C6.66246 5 7.50192 5.83947 7.50192 6.875Z",
        fill: "#F0BB4F",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Số hình ảnh đã upload")
], -1))
const _hoisted_90 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_91 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_92 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center justify-start gap-4\" data-v-828bea96><div data-v-828bea96><div data-v-828bea96><svg fill=\"none\" height=\"20\" viewBox=\"0 0 20 20\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\" data-v-828bea96><g clip-path=\"url(#clip0_16570_9419)\" data-v-828bea96><path d=\"M18.0542 2.5H1.94598C1.69039 2.49995 1.4373 2.55273 1.20115 2.65531C0.965002 2.7579 0.750429 2.90829 0.569684 3.09789C0.388939 3.28749 0.245562 3.51259 0.147741 3.76034C0.0499209 4.00808 -0.000426956 4.27362 -0.000426952 4.54178V15.4582C-0.000567593 15.7265 0.0496765 15.9921 0.147434 16.24C0.245192 16.4879 0.388546 16.7131 0.569305 16.9028C0.750065 17.0926 0.964685 17.243 1.2009 17.3457C1.43712 17.4484 1.6903 17.5012 1.94598 17.5011H18.0542C18.5704 17.5011 19.0653 17.286 19.4303 16.9031C19.7953 16.5202 20.0003 16.0009 20.0003 15.4593V4.54178C20.0003 4.00027 19.7953 3.48093 19.4303 3.09802C19.0653 2.71512 18.5704 2.5 18.0542 2.5ZM9.0269 4.05585H10.973C10.9966 4.05679 11.0195 4.06489 11.0389 4.07917C11.0583 4.09345 11.0733 4.11331 11.0821 4.13634V5.4702H8.95554V4.19736C8.94747 4.16867 8.95042 4.1378 8.96375 4.11136C8.97709 4.08492 8.99975 4.06499 9.0269 4.05585ZM3.91594 15.9232C3.88025 15.9232 3.82495 15.943 3.78855 15.943H1.96882C1.85963 15.943 1.8054 15.9232 1.8054 15.7839V14.5302H3.91522L3.91594 15.9232ZM3.89774 5.48892H1.93313C1.9078 5.49149 1.88243 5.4843 1.86177 5.4687V4.13634C1.87997 4.09629 1.91636 4.0566 1.95276 4.0566H3.86277C3.91736 4.03676 3.95376 4.07644 3.97196 4.13634V4.17603C3.99015 4.57435 3.99015 4.97267 3.99015 5.37062C3.97053 5.43014 3.95233 5.46983 3.89774 5.49004V5.48892ZM7.46264 15.9232C7.40805 15.9232 7.37166 15.943 7.33526 15.943H5.51552C5.44416 15.9629 5.3885 15.9232 5.3521 15.8434V14.5103H7.46193L7.46264 15.9232ZM7.46264 5.50876H5.53586C5.48127 5.50876 5.44523 5.4687 5.40884 5.42902V4.09591H7.37308C7.44445 4.07607 7.50046 4.11575 7.53686 4.19549V5.3504C7.54453 5.3819 7.54128 5.41524 7.52769 5.44445C7.51409 5.47367 7.49104 5.49686 7.46264 5.50988V5.50876ZM11.0093 15.9232C10.9548 15.9232 10.9184 15.943 10.8638 15.943H9.04403C8.93485 15.943 8.89845 15.9232 8.89845 15.7839V14.6496C8.89671 14.6024 8.90287 14.5553 8.91665 14.5103H11.0083L11.0093 15.9232ZM11.3961 10.5683L9.09827 12.0568C8.63869 12.3712 8.25905 12.1406 8.25905 11.5746V8.42992C8.25905 7.84292 8.63869 7.63327 9.09827 7.94774L11.3961 9.43621C11.8557 9.7518 11.8557 10.2538 11.3961 10.5683ZM14.5575 15.8648C14.5393 15.9045 14.5029 15.9441 14.4665 15.9441H12.5397C12.504 15.9441 12.4684 15.9045 12.4487 15.8648V14.5305H14.5575V15.8648ZM14.6485 4.19549C14.6128 4.59382 14.6303 4.9723 14.6303 5.3504C14.6303 5.43014 14.6303 5.49004 14.5393 5.49004H12.5372V4.05623H14.5197C14.533 4.05243 14.547 4.05151 14.5608 4.05351C14.5745 4.05551 14.5877 4.0604 14.5996 4.06788C14.6115 4.07536 14.6218 4.08527 14.63 4.09704C14.6381 4.1088 14.6439 4.12217 14.647 4.13634L14.6485 4.19549ZM18.086 15.9243H15.9929V14.5305H18.0846L18.086 15.9243ZM18.1955 4.25539C18.1599 4.61366 18.177 4.99214 18.177 5.37025C18.177 5.44999 18.1591 5.50988 18.0678 5.50988H16.141C16.1157 5.51236 16.0904 5.50533 16.0696 5.49004V4.07607H18.0339C18.1053 4.05623 18.1613 4.09591 18.1977 4.17565L18.1955 4.25539Z\" fill=\"#6390C3\" data-v-828bea96></path></g><defs data-v-828bea96><clipPath id=\"clip0_16570_9419\" data-v-828bea96><rect fill=\"white\" height=\"15\" transform=\"translate(0 2.5)\" width=\"20\" data-v-828bea96></rect></clipPath></defs></svg></div></div><div data-v-828bea96>Số video đã upload</div></div>", 1)
const _hoisted_93 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_94 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "",
    class: "h-5 w-5",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", null, " Số dung lượng đã upload ")
], -1))
const _hoisted_96 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_97 = { class: "mt-10" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Học sinh ", -1))
const _hoisted_99 = { class: "grid grid-cols-2 items-start md-down:grid-cols-1 mt-2 gap-4" }
const _hoisted_100 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_101 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-start justify-start gap-4\" data-v-828bea96><div data-v-828bea96><svg fill=\"none\" height=\"20\" viewBox=\"0 0 20 20\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\" data-v-828bea96><path clip-rule=\"evenodd\" d=\"M8.75 17.5C8.75 17.5 7.5 17.5 7.5 16.25C7.5 15 8.75 11.25 13.75 11.25C18.75 11.25 20 15 20 16.25C20 17.5 18.75 17.5 18.75 17.5H8.75Z\" fill=\"#2AA797\" fill-rule=\"evenodd\" data-v-828bea96></path><path clip-rule=\"evenodd\" d=\"M13.75 10C15.8211 10 17.5 8.32107 17.5 6.25C17.5 4.17893 15.8211 2.5 13.75 2.5C11.6789 2.5 10 4.17893 10 6.25C10 8.32107 11.6789 10 13.75 10Z\" fill=\"#2AA797\" fill-rule=\"evenodd\" data-v-828bea96></path><path clip-rule=\"evenodd\" d=\"M6.52045 17.5C6.34445 17.1449 6.25 16.7239 6.25 16.25C6.25 14.5557 7.09882 12.8132 8.66991 11.6C7.98262 11.3801 7.18137 11.25 6.25 11.25C1.25 11.25 0 15 0 16.25C0 17.5 1.25 17.5 1.25 17.5H6.52045Z\" fill=\"#2AA797\" fill-rule=\"evenodd\" data-v-828bea96></path><path clip-rule=\"evenodd\" d=\"M5.625 10C7.35089 10 8.75 8.60089 8.75 6.875C8.75 5.14911 7.35089 3.75 5.625 3.75C3.89911 3.75 2.5 5.14911 2.5 6.875C2.5 8.60089 3.89911 10 5.625 10Z\" fill=\"#2AA797\" fill-rule=\"evenodd\" data-v-828bea96></path></svg></div><div data-v-828bea96> Số HS can thiệp cá nhân </div></div>", 1)
const _hoisted_102 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_103 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 20 20",
      width: "20",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M15.4163 13.3327C17.9476 13.3327 19.9997 11.2807 19.9997 8.74935C19.9997 6.21804 17.9476 4.16602 15.4163 4.16602C12.885 4.16602 10.833 6.21804 10.833 8.74935C10.833 11.2807 12.885 13.3327 15.4163 13.3327ZM12.9336 8.36742C12.6172 8.36742 12.3607 8.62392 12.3607 8.94033C12.3607 9.25675 12.6172 9.51325 12.9336 9.51325H17.517C17.8334 9.51325 18.0899 9.25675 18.0899 8.94033C18.0899 8.62392 17.8334 8.36742 17.517 8.36742H12.9336Z",
        fill: "#E37056",
        "fill-rule": "evenodd"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M10.0075 9.03836C9.3432 9.63619 8.46409 10 7.5 10C5.42893 10 3.75 8.32107 3.75 6.25C3.75 4.17893 5.42893 2.5 7.5 2.5C9.28104 2.5 10.7721 3.74162 11.1548 5.40651C10.4314 6.32728 10 7.48826 10 8.75C10 8.84673 10.0025 8.94288 10.0075 9.03836ZM10.879 11.7091C9.95946 11.4238 8.84561 11.25 7.5 11.25C1.25 11.25 0 15 0 16.25C0 17.5 1.25 17.5 1.25 17.5H13.75C13.75 17.5 15 17.5 15 16.25C15 15.7655 14.8122 14.9054 14.2182 14.0336C12.8256 13.7191 11.6363 12.868 10.879 11.7091Z",
        fill: "#E37056",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Số HS tạm dừng")
], -1))
const _hoisted_105 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_106 = { class: "mt-10" }
const _hoisted_107 = { class: "bg-white shadow border-sm p-6 rounded-lg" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 font-semibold text-lg" }, " Kết quả học tập ", -1))
const _hoisted_109 = { class: "relative mt-6 flex items-center" }
const _hoisted_110 = /*#__PURE__*/_createStaticVNode("<div class=\"h-full mr-10 pt-6\" data-v-828bea96><div class=\"flex flex-col items-start justify-between\" style=\"height:200px;\" data-v-828bea96><div class=\"w-full rounded-full text-center text-white text-sm font-semibold py-1 px-4 whitespace-nowrap\" style=\"background:#2aa797;\" data-v-828bea96> Đạt &gt; 75% </div><div class=\"w-full rounded-full text-center text-white text-sm font-semibold py-1 px-4 whitespace-nowrap\" style=\"background:#65a30d;\" data-v-828bea96> Đạt 55-75% </div><div class=\"w-full rounded-full text-center text-white text-sm font-semibold py-1 px-4 whitespace-nowrap\" style=\"background:#f59e0b;\" data-v-828bea96> Đạt 25-55% </div><div class=\"w-full rounded-full text-center text-white text-sm font-semibold py-1 px-4 whitespace-nowrap\" style=\"background:#f87171;\" data-v-828bea96> Đạt &lt; 25% </div></div><div class=\"text-neutral-500 text-sm mt-8 font-medium whitespace-nowrap\" data-v-828bea96> Số học sinh (%) </div></div>", 1)
const _hoisted_111 = { class: "w-full grid grid-cols-10 pt-6 relative" }
const _hoisted_112 = {
  class: "absolute l-0 pt-8 w-full flex flex-col items-start justify-between",
  style: {"height":"216px"}
}
const _hoisted_113 = { class: "text-neutral-500 text-sm mt-8 font-semibold float-right -mr-2" }
const _hoisted_114 = { class: "mt-10" }
const _hoisted_115 = { key: 1 }
const _hoisted_116 = {
  key: 0,
  class: "w-full"
}
const _hoisted_117 = { class: "relative mt-16" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  "aria-hidden": "true",
  class: "absolute inset-0 flex items-center"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-full border-t border-neutral-300" })
], -1))
const _hoisted_119 = { class: "relative flex justify-center" }
const _hoisted_120 = { class: "bg-body px-2 text-neutral-600 font-semibold text-2xl whitespace-nowrap flex flex-nowrap items-center justify-center gap-6" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "12",
  viewBox: "0 0 8 12",
  width: "8",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.5 1L1.5 6L6.5 11",
    stroke: "#48566A",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1))
const _hoisted_122 = [
  _hoisted_121
]
const _hoisted_123 = {
  key: 0,
  class: "flex items-center gap-2.5 cursor-pointer"
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "16",
  viewBox: "0 0 17 16",
  width: "17",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "clip-rule": "evenodd",
    d: "M4.5 0.5C4.5 0.223858 4.27614 0 4 0C3.72386 0 3.5 0.223858 3.5 0.5V1H2.5C1.39543 1 0.5 1.89543 0.5 3V4H16.5V3C16.5 1.89543 15.6046 1 14.5 1H13.5V0.5C13.5 0.223858 13.2761 0 13 0C12.7239 0 12.5 0.223858 12.5 0.5V1H4.5V0.5ZM16.5 14V5H0.5V14C0.5 15.1046 1.39543 16 2.5 16H14.5C15.6046 16 16.5 15.1046 16.5 14ZM10 7C9.72386 7 9.5 7.22386 9.5 7.5V8.5C9.5 8.77614 9.72386 9 10 9H11C11.2761 9 11.5 8.77614 11.5 8.5V7.5C11.5 7.22386 11.2761 7 11 7H10ZM13 7C12.7239 7 12.5 7.22386 12.5 7.5V8.5C12.5 8.77614 12.7239 9 13 9H14C14.2761 9 14.5 8.77614 14.5 8.5V7.5C14.5 7.22386 14.2761 7 14 7H13ZM2.5 10.5C2.5 10.2239 2.72386 10 3 10H4C4.27614 10 4.5 10.2239 4.5 10.5V11.5C4.5 11.7761 4.27614 12 4 12H3C2.72386 12 2.5 11.7761 2.5 11.5V10.5ZM6 10C5.72386 10 5.5 10.2239 5.5 10.5V11.5C5.5 11.7761 5.72386 12 6 12H7C7.27614 12 7.5 11.7761 7.5 11.5V10.5C7.5 10.2239 7.27614 10 7 10H6Z",
    fill: "#48566A",
    "fill-rule": "evenodd"
  })
], -1))
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "12",
  viewBox: "0 0 8 12",
  width: "8",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 11L6.5 6L1.5 1",
    stroke: "#48566A",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2"
  })
], -1))
const _hoisted_126 = [
  _hoisted_125
]
const _hoisted_127 = { class: "mt-10" }
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Chuyên cần theo ngày ", -1))
const _hoisted_129 = { class: "grid grid-cols-3 items-start md-down:grid-cols-1 mt-2 gap-4" }
const _hoisted_130 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 20 20",
      width: "20",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM10 4.375C10 4.02982 9.72018 3.75 9.375 3.75C9.02982 3.75 8.75 4.02982 8.75 4.375V11.25C8.75 11.4743 8.87018 11.6814 9.06491 11.7927L13.4399 14.2927C13.7396 14.4639 14.1214 14.3598 14.2927 14.0601C14.4639 13.7604 14.3598 13.3786 14.0601 13.2073L10 10.8873V4.375Z",
        fill: "#6366F1",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, " Số ngày đã dạy / dự kiến ")
], -1))
const _hoisted_132 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_133 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 24 20",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z",
        fill: "#F1A267",
        "fill-rule": "evenodd"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z",
        fill: "#F1A267",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Số ngày học phát sinh")
], -1))
const _hoisted_135 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_136 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_137 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 24 20",
      width: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M20 8C22.2091 8 24 6.20914 24 4C24 1.79086 22.2091 0 20 0C17.7909 0 16 1.79086 16 4C16 6.20914 17.7909 8 20 8ZM20 1.16667C20.2761 1.16667 20.5 1.39052 20.5 1.66667V3.5H22.3333C22.6095 3.5 22.8333 3.72386 22.8333 4C22.8333 4.27614 22.6095 4.5 22.3333 4.5H20.5V6.33333C20.5 6.60948 20.2761 6.83333 20 6.83333C19.7239 6.83333 19.5 6.60948 19.5 6.33333V4.5H17.6667C17.3905 4.5 17.1667 4.27614 17.1667 4C17.1667 3.72386 17.3905 3.5 17.6667 3.5H19.5V1.66667C19.5 1.39052 19.7239 1.16667 20 1.16667Z",
        fill: "#E68D7B",
        "fill-rule": "evenodd"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M15.1868 2.64204C13.6109 1.50437 11.6754 0.833984 9.58333 0.833984C4.2906 0.833984 0 5.12459 0 10.4173C0 15.71 4.2906 20.0007 9.58333 20.0007C14.8761 20.0007 19.1667 15.71 19.1667 10.4173C19.1667 9.90457 19.1264 9.40124 19.0489 8.91029C16.7423 8.46608 15 6.43684 15 4.00065C15 3.52974 15.0651 3.07403 15.1868 2.64204ZM8.98438 4.42773C9.31517 4.42773 9.58333 4.6959 9.58333 5.02669V11.2676L13.4743 13.491C13.7615 13.6551 13.8612 14.021 13.6971 14.3082C13.533 14.5954 13.1671 14.6952 12.8799 14.5311L8.68721 12.1353C8.50059 12.0286 8.38542 11.8302 8.38542 11.6152V5.02669C8.38542 4.6959 8.65358 4.42773 8.98438 4.42773Z",
        fill: "#E68D7B",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Số ngày nghỉ")
], -1))
const _hoisted_138 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_139 = { class: "mt-10" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Tiến độ hoàn thành báo cáo bán trú (hoàn thành/tổng số) ", -1))
const _hoisted_141 = { class: "grid grid-cols-3 items-start md-down:grid-cols-1 mt-2 gap-4" }
const _hoisted_142 = { class: "flex items-start justify-start gap-4" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    fill: "none",
    height: "20",
    viewBox: "0 0 20 20",
    width: "20",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "M3.33332 0C2.41285 0 1.66666 0.746192 1.66666 1.66667V18.3333C1.66666 19.2538 2.41285 20 3.33332 20H16.6667C17.5871 20 18.3333 19.2538 18.3333 18.3333V1.66667C18.3333 0.746192 17.5871 0 16.6667 0H3.33332ZM4.16666 3.33333C3.70642 3.33333 3.33332 3.70643 3.33332 4.16667C3.33332 4.6269 3.70642 5 4.16666 5H15.4167C15.8769 5 16.25 4.6269 16.25 4.16667C16.25 3.70643 15.8769 3.33333 15.4167 3.33333H4.16666ZM3.74999 7.5C3.74999 7.26988 3.93654 7.08333 4.16666 7.08333H8.33332C8.56344 7.08333 8.74999 7.26988 8.74999 7.5C8.74999 7.73012 8.56344 7.91667 8.33332 7.91667H4.16666C3.93654 7.91667 3.74999 7.73012 3.74999 7.5ZM4.16666 8.75C3.93654 8.75 3.74999 8.93655 3.74999 9.16667C3.74999 9.39678 3.93654 9.58333 4.16666 9.58333H8.33332C8.56344 9.58333 8.74999 9.39678 8.74999 9.16667C8.74999 8.93655 8.56344 8.75 8.33332 8.75H4.16666ZM3.74999 10.8333C3.74999 10.6032 3.93654 10.4167 4.16666 10.4167H8.33332C8.56344 10.4167 8.74999 10.6032 8.74999 10.8333C8.74999 11.0635 8.56344 11.25 8.33332 11.25H4.16666C3.93654 11.25 3.74999 11.0635 3.74999 10.8333ZM14.7917 10C14.5328 10 14.3229 10.2099 14.3229 10.4688V16.0938H13.8542V12.8125C13.8542 12.5536 13.6443 12.3438 13.3854 12.3438H12.4479C12.189 12.3438 11.9792 12.5536 11.9792 12.8125V16.0938H11.5104V14.6875C11.5104 14.4286 11.3005 14.2188 11.0417 14.2188H10.1042C9.84527 14.2188 9.63541 14.4286 9.63541 14.6875V16.0938H9.40103C9.27159 16.0938 9.16666 16.1987 9.16666 16.3281C9.16666 16.4576 9.27159 16.5625 9.40103 16.5625H16.4323C16.5617 16.5625 16.6667 16.4576 16.6667 16.3281C16.6667 16.1987 16.5617 16.0938 16.4323 16.0938H16.1979V10.4688C16.1979 10.2099 15.988 10 15.7292 10H14.7917Z",
      fill: "#41BEAD",
      "fill-rule": "evenodd"
    })
  ])
], -1))
const _hoisted_144 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_145 = { class: "mt-10" }
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "font-semibold text-neutral-500" }, " Lớp bán trú đang dạy ", -1))
const _hoisted_147 = { class: "flex items-center justify-between mb-1" }
const _hoisted_148 = { class: "font-semibold flex gap-2 items-center text-neutral-500" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  fill: "none",
  height: "20",
  viewBox: "0 0 20 20",
  width: "20",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M5.99666 20C6.21401 19.9999 6.4291 19.9559 6.62903 19.8706C6.82897 19.7854 7.00964 19.6607 7.16022 19.5039C7.3108 19.3472 7.42819 19.1617 7.50536 18.9585C7.58253 18.7553 7.61788 18.5386 7.60931 18.3214L7.33907 9.88249L8.5167 9.17284C8.8171 8.99077 9.06357 8.73196 9.23077 8.42305C9.39797 8.11413 9.47987 7.76625 9.46803 7.41518L9.23294 0.617447C9.22724 0.453467 9.15807 0.298112 9.04002 0.184158C8.92197 0.0702041 8.76427 0.00656322 8.60019 0.00666215C8.43688 0.00828381 8.28053 0.0729825 8.16383 0.187227C8.04713 0.301471 7.97912 0.456412 7.97402 0.619645L7.80924 4.85559C7.80781 4.98185 7.76112 5.1034 7.67766 5.19815C7.5942 5.2929 7.47951 5.35455 7.35445 5.37191C7.28497 5.37951 7.21467 5.37268 7.14795 5.35184C7.08124 5.33101 7.01954 5.29662 6.96674 5.25082C6.91393 5.20503 6.87116 5.14883 6.84109 5.08573C6.81102 5.02264 6.79431 4.95401 6.792 4.88416L6.62722 0.643812C6.62335 0.498377 6.57147 0.358308 6.47966 0.245442C6.38786 0.132576 6.26129 0.0532551 6.1197 0.0198446C6.03534 0.00562738 5.94919 0.00562738 5.86484 0.0198446C5.72324 0.0532551 5.59667 0.132576 5.50487 0.245442C5.41306 0.358308 5.36118 0.498377 5.35731 0.643812L5.19253 4.88416C5.19022 4.95401 5.17351 5.02264 5.14344 5.08573C5.11337 5.14883 5.0706 5.20503 5.01779 5.25082C4.96499 5.29662 4.9033 5.33101 4.83658 5.35184C4.76986 5.37268 4.69956 5.37951 4.63008 5.37191C4.50502 5.35455 4.39033 5.2929 4.30687 5.19815C4.22341 5.1034 4.17672 4.98185 4.17529 4.85559L4.00392 0.619645C3.99875 0.45336 3.92829 0.295802 3.80781 0.181078C3.68733 0.0663532 3.52652 0.00369344 3.36018 0.00666215C3.1961 0.00656322 3.0384 0.0702041 2.92034 0.184158C2.80229 0.298112 2.73312 0.453467 2.72742 0.617447L2.50112 7.41738C2.48929 7.76844 2.57118 8.11632 2.73838 8.42524C2.90558 8.73416 3.15206 8.99296 3.45245 9.17503L4.65205 9.89567L4.38181 18.3214C4.37323 18.5388 4.40865 18.7557 4.48596 18.959C4.56326 19.1623 4.68085 19.3479 4.83166 19.5047C4.98248 19.6615 5.16341 19.7862 5.36361 19.8713C5.5638 19.9564 5.77913 20.0002 5.99666 20Z",
    fill: "#3B82F6"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.8125 8.24569C18.1252 7.6708 18.287 7.026 18.2827 6.37159C18.2673 4.22065 17.8784 0.0220559 14.7872 8.5179e-05C11.6959 -0.0218855 11.307 4.21187 11.2916 6.37159C11.2866 7.0258 11.4477 7.6706 11.7596 8.24569C12.0901 8.85577 12.5779 9.3663 13.1723 9.72431L13.4623 9.90008L13.1943 18.3214C13.1863 18.5355 13.2216 18.7489 13.298 18.9489C13.3744 19.149 13.4904 19.3316 13.639 19.4858C13.7876 19.64 13.9658 19.7627 14.1629 19.8465C14.3599 19.9303 14.5719 19.9735 14.7861 19.9735C15.0002 19.9735 15.2122 19.9303 15.4093 19.8465C15.6063 19.7627 15.7845 19.64 15.9331 19.4858C16.0817 19.3316 16.1977 19.149 16.2741 18.9489C16.3505 18.7489 16.3858 18.5355 16.3778 18.3214L16.1032 9.89568L16.3932 9.71992C16.9894 9.36403 17.4795 8.855 17.8125 8.24569Z",
    fill: "#3B82F6"
  })
], -1))
const _hoisted_150 = ["onClick"]
const _hoisted_151 = { class: "grid grid-cols-3 items-start md-down:grid-cols-1 mt-2 gap-4" }
const _hoisted_152 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_153 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-start justify-start gap-4\" data-v-828bea96><div data-v-828bea96><svg fill=\"none\" height=\"20\" viewBox=\"0 0 20 20\" width=\"20\" xmlns=\"http://www.w3.org/2000/svg\" data-v-828bea96><g clip-path=\"url(#clip0_24861_12969)\" data-v-828bea96><path d=\"M7 9.75C6.31 9.75 5.75 10.31 5.75 11C5.75 11.69 6.31 12.25 7 12.25C7.69 12.25 8.25 11.69 8.25 11C8.25 10.31 7.69 9.75 7 9.75ZM13 9.75C12.31 9.75 11.75 10.31 11.75 11C11.75 11.69 12.31 12.25 13 12.25C13.69 12.25 14.25 11.69 14.25 11C14.25 10.31 13.69 9.75 13 9.75ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 9.71 2.02 9.42 2.05 9.14C4.41 8.09 6.28 6.16 7.26 3.77C9.07 6.33 12.05 8 15.42 8C16.2 8 16.95 7.91 17.67 7.74C17.88 8.45 18 9.21 18 10C18 14.41 14.41 18 10 18Z\" fill=\"#2AA797\" data-v-828bea96></path><path d=\"M8 13.9895C8 13.9895 9.86667 18.4895 12 13.9895H8Z\" fill=\"#2AA797\" data-v-828bea96></path></g><defs data-v-828bea96><clipPath id=\"clip0_24861_12969\" data-v-828bea96><rect fill=\"white\" height=\"20\" width=\"20\" data-v-828bea96></rect></clipPath></defs></svg></div><div data-v-828bea96>Học sinh</div></div>", 1)
const _hoisted_154 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_155 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_156 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-start justify-start gap-4\" data-v-828bea96><div data-v-828bea96><svg fill=\"none\" height=\"20\" viewBox=\"0 0 21 20\" width=\"21\" xmlns=\"http://www.w3.org/2000/svg\" data-v-828bea96><path d=\"M17.5019 15.4634C16.6131 14.0316 14.6609 12.5 10.6667 12.5C6.67251 12.5 4.72038 14.0316 3.83154 15.4634C5.43501 17.4668 7.90102 18.75 10.6667 18.75C13.4324 18.75 15.8984 17.4668 17.5019 15.4634Z\" fill=\"#86A8D0\" data-v-828bea96></path><path clip-rule=\"evenodd\" d=\"M10.6665 11.25C12.7376 11.25 14.4165 9.57107 14.4165 7.5C14.4165 5.42893 12.7376 3.75 10.6665 3.75C8.59544 3.75 6.9165 5.42893 6.9165 7.5C6.9165 9.57107 8.59544 11.25 10.6665 11.25Z\" fill=\"#86A8D0\" fill-rule=\"evenodd\" data-v-828bea96></path><path clip-rule=\"evenodd\" d=\"M10.6665 1.25C5.83401 1.25 1.9165 5.16751 1.9165 10C1.9165 14.8325 5.83401 18.75 10.6665 18.75C15.499 18.75 19.4165 14.8325 19.4165 10C19.4165 5.16751 15.499 1.25 10.6665 1.25ZM0.666504 10C0.666504 4.47715 5.14366 0 10.6665 0C16.1894 0 20.6665 4.47715 20.6665 10C20.6665 15.5228 16.1894 20 10.6665 20C5.14366 20 0.666504 15.5228 0.666504 10Z\" fill=\"#86A8D0\" fill-rule=\"evenodd\" data-v-828bea96></path></svg></div><div data-v-828bea96>Giáo viên bán trú</div></div>", 1)
const _hoisted_157 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_158 = { class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between" }
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-start justify-start gap-4" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("svg", {
      fill: "none",
      height: "20",
      viewBox: "0 0 21 20",
      width: "21",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        "clip-rule": "evenodd",
        d: "M5.3335 0.625C5.3335 0.279822 5.05367 0 4.7085 0C4.36332 0 4.0835 0.279822 4.0835 0.625V1.25H2.8335C1.45278 1.25 0.333496 2.36929 0.333496 3.75V5H20.3335V3.75C20.3335 2.36929 19.2142 1.25 17.8335 1.25H16.5835V0.625C16.5835 0.279822 16.3037 0 15.9585 0C15.6133 0 15.3335 0.279822 15.3335 0.625V1.25H5.3335V0.625ZM20.3335 17.5V6.25H0.333496V17.5C0.333496 18.8807 1.45279 20 2.8335 20H17.8335C19.2142 20 20.3335 18.8807 20.3335 17.5ZM12.2085 8.75C11.8633 8.75 11.5835 9.02982 11.5835 9.375V10.625C11.5835 10.9702 11.8633 11.25 12.2085 11.25H13.4585C13.8037 11.25 14.0835 10.9702 14.0835 10.625V9.375C14.0835 9.02982 13.8037 8.75 13.4585 8.75H12.2085ZM15.9585 8.75C15.6133 8.75 15.3335 9.02982 15.3335 9.375V10.625C15.3335 10.9702 15.6133 11.25 15.9585 11.25H17.2085C17.5537 11.25 17.8335 10.9702 17.8335 10.625V9.375C17.8335 9.02982 17.5537 8.75 17.2085 8.75H15.9585ZM2.8335 13.125C2.8335 12.7798 3.11332 12.5 3.4585 12.5H4.7085C5.05367 12.5 5.3335 12.7798 5.3335 13.125V14.375C5.3335 14.7202 5.05367 15 4.7085 15H3.4585C3.11332 15 2.8335 14.7202 2.8335 14.375V13.125ZM7.2085 12.5C6.86332 12.5 6.5835 12.7798 6.5835 13.125V14.375C6.5835 14.7202 6.86332 15 7.2085 15H8.4585C8.80367 15 9.0835 14.7202 9.0835 14.375V13.125C9.0835 12.7798 8.80367 12.5 8.4585 12.5H7.2085Z",
        fill: "#F0BB4F",
        "fill-rule": "evenodd"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, "Ngày học")
], -1))
const _hoisted_160 = { class: "text-4xl font-bold mt-4 text-neutral-600" }
const _hoisted_161 = {
  key: 2,
  class: "flex items-center"
}
const _hoisted_162 = { class: "w-full max-w-lg" }
const _hoisted_163 = {
  key: 0,
  class: "w-7/12 flex items-center justify-center xl-down:w-full p-6"
}
const _hoisted_164 = { class: "flex items-center justify-center flex-col" }
const _hoisted_165 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-600 font-semibold mt-1" }, " Tài khoản đang khoá ", -1))
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-neutral-500 mt-1 text-center" }, " Bạn hãy kich hoạt tài khoản cho trị liệu viên để xem thống kê nhé ", -1))
const _hoisted_167 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChangeStatus = _resolveComponent("ChangeStatus")!
  const _component_ChangeStatusAssignedDaycareClass = _resolveComponent("ChangeStatusAssignedDaycareClass")!
  const _component_ChangeStatusAssigned = _resolveComponent("ChangeStatusAssigned")!
  const _component_LeaveReport = _resolveComponent("LeaveReport")!
  const _component_DaModalFrame = _resolveComponent("DaModalFrame")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_DaIcon = _resolveComponent("DaIcon")!
  const _component_VueDatepicker = _resolveComponent("VueDatepicker")!
  const _component_Analytics = _resolveComponent("Analytics")!
  const _component_InformationTable = _resolveComponent("InformationTable")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DaModalFrame, {
      open: _ctx.modalIsOpen,
      "onUpdate:open": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalIsOpen) = $event))
    }, {
      default: _withCtx(() => [
        (_ctx.modalType === _ctx.ModalType.CHANGE_STATUS)
          ? (_openBlock(), _createBlock(_component_ChangeStatus, {
              key: 0,
              "active-mode": _ctx.activeMode,
              isStudent: false,
              staff: _ctx.staff,
              onActive: _ctx.activeStaff,
              onBlock: _ctx.closeStaff,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalIsOpen = false))
            }, null, 8, ["active-mode", "staff", "onActive", "onBlock"]))
          : _createCommentVNode("", true),
        (
				_ctx.modalType === _ctx.ModalType.ERROR && _ctx.errorAssignedDayClasses.length
			)
          ? (_openBlock(), _createBlock(_component_ChangeStatusAssignedDaycareClass, {
              key: 1,
              data: _ctx.errorAssignedDayClasses,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalIsOpen = false))
            }, null, 8, ["data"]))
          : _createCommentVNode("", true),
        (_ctx.modalType === _ctx.ModalType.ERROR && _ctx.errorAssigned.length)
          ? (_openBlock(), _createBlock(_component_ChangeStatusAssigned, {
              key: 2,
              data: _ctx.errorAssigned,
              onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalIsOpen = false))
            }, null, 8, ["data"]))
          : _createCommentVNode("", true),
        (_ctx.modalType === _ctx.ModalType.LEAVE_REPORT)
          ? (_openBlock(), _createBlock(_component_LeaveReport, { key: 3 }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["open"]),
    _createElementVNode("div", _hoisted_1, [
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_router_link, {
                to: { name: _ctx.routerName.RECORD_EMPLOYEE }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Hồ sơ ")
                ]),
                _: 1
              }, 8, ["to"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_DaIcon, {
                  class: "transform -rotate-90 h-3 w-3 mx-2",
                  name: "das--chevron-down"
                })
              ]),
              _hoisted_5
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.staff?.profile_photo?.w200)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.staff?.profile_photo?.w200,
                        alt: "",
                        class: "shadow-sm inline-block h-14 w-14 rounded-full",
                        style: {"min-width":"56px"}
                      }, null, 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        style: _normalizeStyle([{
								background:
									_ctx.staff?.profile_photo?.default?.color,
							}, {"min-width":"56px"}]),
                        class: "inline-flex items-center justify-center h-14 w-14 rounded-full"
                      }, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.staff?.profile_photo?.default?.initial), 1)
                      ], 4)),
                  (_ctx.staff.state !== 'active')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.staff.full_name) + " | " + _toDisplayString(_ctx.staff.name), 1),
                  (_ctx.staff.state === 'active')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _createTextVNode(" TÀI KHOẢN ĐÃ KÍCH HOẠT ")
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.staff.state !== 'active')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _createTextVNode(" TÀI KHOẢN ĐÃ KHÓA ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              false
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("button", {
                      class: "button-p text-center mt-6 btn--ghost",
                      type: "button",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModel(_ctx.ModalType.LEAVE_REPORT)))
                    }, " Báo nghỉ "),
                    _hoisted_21
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("nav", _hoisted_24, [
                    (!_ctx.notAnalytics && _ctx.staff.has_assignment && _ctx.centerState !== 'community')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass([{
									selected:
										_ctx.tab ===
										_ctx.routerName.RECORD_EMPLOYEE_STATS,
								}, "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"]),
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (
									_ctx.selectTab(_ctx.routerName.RECORD_EMPLOYEE_STATS)
								))
                        }, [
                          _createTextVNode(" Thống kê "),
                          (
										_ctx.staff.has_assignment &&
										_ctx.staff.has_staff_day_care_membership 
									)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Can Thiệp"))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true),
                    (
									!_ctx.notAnalytics &&
									_ctx.staff.has_staff_day_care_membership
									&& _ctx.centerState !== 'community'
								)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass([{
									selected:
										_ctx.tab ===
										_ctx.routerName.RECORD_EMPLOYEE_STATS_DAYCARE,
								}, "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"]),
                          onClick: _cache[6] || (_cache[6] = ($event: any) => (
									_ctx.selectTab(
										_ctx.routerName.RECORD_EMPLOYEE_STATS_DAYCARE
									)
								))
                        }, [
                          _createTextVNode(" Thống kê "),
                          (
										_ctx.staff.has_assignment &&
										_ctx.staff.has_staff_day_care_membership
									)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Bán trú"))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass([{
									selected:
										_ctx.tab ===
										_ctx.routerName.RECORD_EMPLOYEE_DETAIL_INFO,
								}, "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold cursor-pointer"]),
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (
									_ctx.selectTab(
										_ctx.routerName.RECORD_EMPLOYEE_DETAIL_INFO
									)
								))
                    }, " Thông tin cá nhân ", 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                (_ctx.tab === _ctx.routerName.RECORD_EMPLOYEE_STATS)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      (!_ctx.notAnalytics)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createElementVNode("div", _hoisted_32, [
                                  _createElementVNode("div", _hoisted_33, [
                                    (
													_ctx.date.month > 0 ||
													_ctx.date.year > 2023
												)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "cursor-pointer",
                                          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.prevDay && _ctx.prevDay(...args)))
                                        }, _hoisted_35))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_VueDatepicker, {
                                      modelValue: _ctx.date,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.date) = $event)),
                                      "max-date": new Date(),
                                      "min-date": new Date(2023, 1, 0),
                                      "auto-apply": "",
                                      class: "input-date-dashboard",
                                      format: "MM/yyyy",
                                      "month-picker": "",
                                      placeholder: "Chọn tháng",
                                      uid: "filter-by-date"
                                    }, {
                                      trigger: _withCtx(() => [
                                        (_ctx.date)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                              _hoisted_37,
                                              _createElementVNode("span", null, "Tháng " + _toDisplayString(_ctx.dateTitle), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "max-date", "min-date"]),
                                    (
													_ctx.date.month <
														new Date().getMonth() ||
													_ctx.date.year <
														new Date().getFullYear()
												)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "cursor-pointer",
                                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.nextDay && _ctx.nextDay(...args)))
                                        }, _hoisted_39))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_40, [
                                _hoisted_41,
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("div", _hoisted_43, [
                                    _hoisted_44,
                                    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.dataStats?.session_stats
														?.total_created_hours) + "/ " + _toDisplayString(_ctx.dataStats?.session_stats
														?.total_scheduled_hours), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_46, [
                                    _hoisted_47,
                                    _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.dataStats?.session_stats
														?.total_unscheduled_hours), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_49, [
                                    _hoisted_50,
                                    _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.dataStats?.session_stats
														?.total_cancelled_by_staff_hours), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    _hoisted_53,
                                    _createElementVNode("div", _hoisted_54, _toDisplayString(_ctx.dataStats?.session_stats
														?.total_cancelled_by_student_hours), 1)
                                  ])
                                ])
                              ]),
                              false
                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                    _hoisted_56,
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("div", _hoisted_58, [
                                        _hoisted_59,
                                        _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.dataStats?.session_stats
														?.total_created_days) + "/ " + _toDisplayString(_ctx.dataStats.session_stats
														.total_scheduled_days), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_61, [
                                        _hoisted_62,
                                        _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.dataStats?.session_stats
														?.total_unscheduled_days), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_64, [
                                        _hoisted_65,
                                        _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.dataStats?.session_stats
														?.total_cancelled_by_staff_days), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_67, [
                                        _hoisted_68,
                                        _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.dataStats?.session_stats
														?.total_cancelled_by_student_days), 1)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_70, [
                                _hoisted_71,
                                _createElementVNode("div", _hoisted_72, [
                                  _createElementVNode("div", _hoisted_73, [
                                    _hoisted_74,
                                    _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.dataStats
														?.lesson_report_stats
														?.numbers_of_completed_lesson_report) + "/" + _toDisplayString(_ctx.dataStats
														?.lesson_report_stats
														?.numbers_of_lesson_report), 1)
                                  ]),
                                  (
												_ctx.dataStats?.weekly_report_stats
											)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                        _hoisted_77,
                                        _createElementVNode("div", _hoisted_78, _toDisplayString(_ctx.dataStats
														?.weekly_report_stats
														?.numbers_of_completed_weekly_report) + "/" + _toDisplayString(_ctx.dataStats
														?.weekly_report_stats
														?.numbers_of_weekly_report), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", _hoisted_79, [
                                    _hoisted_80,
                                    _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.dataStats
														?.monthly_report_stats
														?.numbers_of_completed_monthly_report) + "/" + _toDisplayString(_ctx.dataStats
														?.monthly_report_stats
														?.numbers_of_monthly_report), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_82, [
                                    _hoisted_83,
                                    _createElementVNode("div", _hoisted_84, _toDisplayString(_ctx.dataStats?.plan_stats
														?.numbers_of_done_plan ||
													0) + "/ " + _toDisplayString(_ctx.dataStats?.plan_stats
														?.numbers_of_plan), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_85, [
                                _hoisted_86,
                                _createElementVNode("div", _hoisted_87, [
                                  _createElementVNode("div", _hoisted_88, [
                                    _hoisted_89,
                                    _createElementVNode("div", _hoisted_90, _toDisplayString(_ctx.dataStats?.media_stats
														?.numbers_of_image), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_91, [
                                    _hoisted_92,
                                    _createElementVNode("div", _hoisted_93, _toDisplayString(_ctx.dataStats?.media_stats
														?.numbers_of_video), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_94, [
                                    _hoisted_95,
                                    _createElementVNode("div", _hoisted_96, _toDisplayString(_ctx.dataStats?.media_stats
														?.used_size), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_97, [
                                _hoisted_98,
                                _createElementVNode("div", _hoisted_99, [
                                  _createElementVNode("div", _hoisted_100, [
                                    _hoisted_101,
                                    _createElementVNode("div", _hoisted_102, _toDisplayString(_ctx.dataStats?.student_stats
														?.numbers_of_student), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_103, [
                                    _hoisted_104,
                                    _createElementVNode("div", _hoisted_105, _toDisplayString(_ctx.dataStats?.student_stats
														?.numbers_of_disabled_assignment), 1)
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_106, [
                              _createElementVNode("div", _hoisted_107, [
                                _hoisted_108,
                                _createElementVNode("div", _hoisted_109, [
                                  _hoisted_110,
                                  _createElementVNode("div", _hoisted_111, [
                                    _createElementVNode("div", _hoisted_112, [
                                      _createElementVNode("div", {
                                        style: _normalizeStyle([{
														width:
															_ctx.dataStats
																?.assessment_stats
																?.assessment_more_than_seventy_percent +
															'%',
													}, {"height":"15px","background":"#2aa797","border-radius":"0 99px\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t99px 0"}])
                                      }, null, 4),
                                      _createElementVNode("div", {
                                        style: _normalizeStyle([{
														width:
															_ctx.dataStats
																?.assessment_stats
																?.assessment_less_than_seventy_percent +
															'%',
													}, {"height":"15px","background":"#65a30d","border-radius":"0 99px\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t99px 0"}])
                                      }, null, 4),
                                      _createElementVNode("div", {
                                        style: _normalizeStyle([{
														width:
															_ctx.dataStats
																?.assessment_stats
																?.assessment_less_than_sixty_percent +
															'%',
													}, {"height":"15px","background":"#f59e0b","border-radius":"0 99px\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t99px 0"}])
                                      }, null, 4),
                                      _createElementVNode("div", {
                                        style: _normalizeStyle([{
														width:
															_ctx.dataStats
																?.assessment_stats
																?.assessment_less_than_fifty_percent +
															'%',
													}, {"height":"15px","background":"#f87171","border-radius":"0 99px\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t99px 0"}])
                                      }, null, 4)
                                    ]),
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (i) => {
                                      return _createElementVNode("div", { key: i }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass([{
														'border-r-0': i !== 10,
													}, "border border-t-0 border-b-0 border-l border-neutral-200"]),
                                          style: {"height":"200px"}
                                        }, null, 2),
                                        _createElementVNode("div", _hoisted_113, _toDisplayString(i * 10), 1)
                                      ])
                                    }), 64))
                                  ])
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_114, [
                              _createVNode(_component_Analytics, {
                                assessments_map: 
										_ctx.dataStats?.assessments_map
									,
                                students: _ctx.dataStats?.students
                              }, null, 8, ["assessments_map", "students"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === _ctx.routerName.RECORD_EMPLOYEE_STATS_DAYCARE)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_115, [
                      (!_ctx.notAnalytics)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_116, [
                            _createElementVNode("div", null, [
                              _createElementVNode("div", _hoisted_117, [
                                _hoisted_118,
                                _createElementVNode("div", _hoisted_119, [
                                  _createElementVNode("div", _hoisted_120, [
                                    (
													_ctx.date.month > 0 ||
													_ctx.date.year > 2023
												)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          class: "cursor-pointer",
                                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.prevDay && _ctx.prevDay(...args)))
                                        }, _hoisted_122))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_VueDatepicker, {
                                      modelValue: _ctx.date,
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.date) = $event)),
                                      "max-date": new Date(),
                                      "min-date": new Date(2023, 1, 0),
                                      "auto-apply": "",
                                      class: "input-date-dashboard",
                                      format: "MM/yyyy",
                                      "month-picker": "",
                                      placeholder: "Chọn tháng",
                                      uid: "filter-by-date"
                                    }, {
                                      trigger: _withCtx(() => [
                                        (_ctx.date)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_123, [
                                              _hoisted_124,
                                              _createElementVNode("span", null, "Tháng " + _toDisplayString(_ctx.dateTitle), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "max-date", "min-date"]),
                                    (
													_ctx.date.month <
														new Date().getMonth() ||
													_ctx.date.year <
														new Date().getFullYear()
												)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 1,
                                          class: "cursor-pointer",
                                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.nextDay && _ctx.nextDay(...args)))
                                        }, _hoisted_126))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_127, [
                                _hoisted_128,
                                _createElementVNode("div", _hoisted_129, [
                                  _createElementVNode("div", _hoisted_130, [
                                    _hoisted_131,
                                    _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.dataStatsDayCare
														?.class_session_stats
														?.created_count) + "/ " + _toDisplayString(_ctx.dataStatsDayCare
														?.class_session_stats
														?.scheduled_count), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_133, [
                                    _hoisted_134,
                                    _createElementVNode("div", _hoisted_135, _toDisplayString(_ctx.dataStatsDayCare
														?.class_session_stats
														?.unscheduled_count), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_136, [
                                    _hoisted_137,
                                    _createElementVNode("div", _hoisted_138, _toDisplayString(_ctx.dataStatsDayCare
														?.class_session_stats
														?.cancelled_count), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_139, [
                                _hoisted_140,
                                _createElementVNode("div", _hoisted_141, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataStatsDayCare.day_care_class, (day_care_class) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: day_care_class.id,
                                      class: "w-full h-full text-neutral-500 px-6 py-4 rounded-lg bg-white shadow border-sm flex flex-col items-start justify-between"
                                    }, [
                                      _createElementVNode("div", _hoisted_142, [
                                        _hoisted_143,
                                        _createElementVNode("div", null, " BC lớp " + _toDisplayString(day_care_class.name), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_144, _toDisplayString(_ctx.dataStatsDayCare
														?.report_stats[
														day_care_class.id
													]?.completed_report_count ||
													0) + "/" + _toDisplayString(_ctx.dataStatsDayCare
														?.report_stats[
														day_care_class.id
													]?.total_report || 0), 1)
                                    ]))
                                  }), 128))
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_145, [
                                _hoisted_146,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataStatsDayCare.day_care_class, (day_care_class) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: day_care_class.id,
                                    class: "mt-6"
                                  }, [
                                    _createElementVNode("div", _hoisted_147, [
                                      _createElementVNode("div", _hoisted_148, [
                                        _hoisted_149,
                                        _createTextVNode(" " + _toDisplayString(day_care_class?.name), 1)
                                      ]),
                                      _createElementVNode("div", {
                                        class: "text-neutral-400 cursor-pointer",
                                        onClick: ($event: any) => (_ctx.$router.push(`/daycare-class/${day_care_class?.id}`))
                                      }, " Xem thêm ", 8, _hoisted_150)
                                    ]),
                                    _createElementVNode("div", _hoisted_151, [
                                      _createElementVNode("div", _hoisted_152, [
                                        _hoisted_153,
                                        _createElementVNode("div", _hoisted_154, _toDisplayString(day_care_class?.number_of_student), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_155, [
                                        _hoisted_156,
                                        _createElementVNode("div", _hoisted_157, _toDisplayString(day_care_class?.number_of_staff), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_158, [
                                        _hoisted_159,
                                        _createElementVNode("div", _hoisted_160, _toDisplayString(_ctx.dayOfWeekDisplay(
															day_care_class.class_day_slots
														)), 1)
                                      ])
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.tab === _ctx.routerName.RECORD_EMPLOYEE_DETAIL_INFO)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_161, [
                      _createElementVNode("div", _hoisted_162, [
                        (_ctx.staff)
                          ? (_openBlock(), _createBlock(_component_InformationTable, {
                              key: 0,
                              staff: _ctx.staff,
                              onSubmit: _ctx.updateStaff,
                              onUpdated: _ctx.updatedAvatar
                            }, null, 8, ["staff", "onSubmit", "onUpdated"]))
                          : _createCommentVNode("", true),
                        (
									!_ctx.notAnalytics &&
									_ctx.setup?.store?.state?.profile?.staff?.id !==
										_ctx.staff?.id &&
									_ctx.isAdmin
								)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: "font-semibold text-yellow-700 underline text-sm mt-6 text-right cursor-pointer",
                              onClick: _cache[14] || (_cache[14] = ($event: any) => (
									_ctx.openModel(_ctx.ModalType.CHANGE_STATUS, false)
								))
                            }, " Khoá tài khoản? "))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.notAnalytics)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_163, [
                            _createElementVNode("div", _hoisted_164, [
                              _createVNode(_component_DaIcon, {
                                class: "h-16 w-16 text-neutral-200",
                                name: "das--user-close"
                              }),
                              _hoisted_165,
                              _hoisted_166,
                              _createElementVNode("button", {
                                class: "button-p w-fit mt-6",
                                type: "button",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openModel(_ctx.ModalType.CHANGE_STATUS)))
                              }, " Kích hoạt tài khoản ")
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_167, [
            _createVNode(_component_Loading)
          ]))
    ])
  ], 64))
}